import gql from 'graphql-tag';

export const DeleteParticipantRestrictivePractice = gql`
  mutation deleteParticipantRestrictivePractice(
    $organizationId: ID!
    $participantId: ID!
    $restrictivePracticeId: ID!
  ) {
    deleteParticipantRestrictivePractice(
      organizationId: $organizationId
      participantId: $participantId
      restrictivePracticeId: $restrictivePracticeId
    ) {
      id
    }
  }
`;
